import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { DoorDashMenuStatusDto, DoorDashStatusDto } from "src/app/shared/models/DTO/DoorDashStatus.dto";

@Component({
	selector: "app-integration-doordash-setup",
	templateUrl: "./integration-doordash-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class IntegrationDoordashSetupComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	doorDashMenuStatus: DoorDashMenuStatusDto;
	doorDashStatus: DoorDashStatusDto;

	constructor(public app: AppService, public venueSvc: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		if (this.venueSvc.ooVenue.doordashMenuId) {
			this.status();
			this.menuStatus();
		}
		if (
			!this.venueSvc.subscriptionOOmenuConfig.value.venueKey ||
			this.venueSvc.subscriptionOOmenuConfig.value.venueKey !== this.venueSvc.subscriptionVenue.value.key
		) {
			this.venueSvc.ooMenuConfigGet();
		}
	}

	async status() {
		const resp = await this.focuslink.doorDashGetVenueStatus(this.venueSvc.venueKey);
		this.doorDashStatus = resp;
		return this.doorDashStatus;
	}

	async menuStatus() {
		const resp = await this.focuslink.doorDashGetVenueMenuStatus(this.venueSvc.venueKey);
		this.doorDashMenuStatus = resp;
		return this.doorDashMenuStatus;
	}

	async uploadDoorDashMenu() {
		try {
			await this.focuslink.patchDoorDashMenu(this.venueSvc.venueKey, this.venueSvc.ooVenue.doordashOOMenuId);
			this.app.msgSvc.add({ severity: "success", detail: "DoorDash Menu Update Requested" });
		} catch (error) {
			this.app.msgSvc.add({ severity: "error", detail: "Error uploading DoorDash menu" });
		}
	}
}
